import getFactionIconName from '@/atoms/FactionIcon/utils';
import { yupResolver } from '@hookform/resolvers/yup';
import { useModal } from 'context/Modal/Context';
import { usePutEvent } from 'hooks/queries/events';
import { useFactions } from 'hooks/queries/factions';
import { useForm } from 'react-hook-form';
import { useCMSmodals } from 'utils/cms';
import { formatVisualOptions } from 'utils/form/formatOptions';
import * as yup from 'yup';

const schema = () =>
  yup.object({
    faction: yup.string().required(),
  });

type FormValues = yup.InferType<ReturnType<typeof schema>>;

const useCloseTumultEvents = ({ eventId }: { eventId: string }) => {
  const { data: factions, isLoading: isFactionsLoading } = useFactions();
  const {
    queryResult: { data, isLoading },
  } = useCMSmodals({ cmsModalName: 'event-finalize-tumult' });

  const factionsOptions = formatVisualOptions(factions, {
    valueField: '@id',
    getIconField: (faction) => getFactionIconName(faction.reference),
  });

  const formMethods = useForm<FormValues>({
    mode: 'onSubmit',
    resolver: yupResolver(schema()),
  });
  const { closeModal } = useModal();
  const { handleSubmit } = formMethods;
  const onSuccess = () => {
    closeModal();
  };
  const { putEvent } = usePutEvent(onSuccess);

  const onSubmit = (formValues: FormValues) => {
    putEvent.mutate({ event: { status: 'FINISHED', winningFaction: formValues.faction }, id: eventId });
  };

  return {
    factionsOptions,
    handleSubmit: handleSubmit(onSubmit),
    formMethods,
    isLoading: isLoading || isFactionsLoading,
    cms: data,
  };
};

export default useCloseTumultEvents;
